import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, reactive, toRefs } from "vue";
export default {
  __name: 'rAIndexItem',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, "报告单内容");
    };
  }
};